var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopWhiteTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M689.3,50.2l-19.9,82.8c79.6,32.8,146.6,89.8,192.4,164.6,57.2,93.3,74.5,203.4,48.9,309.8-25.6,106.4-91.1,196.5-184.4,253.7-65.2,39.9-138.6,60.5-213.2,60.5s-22-.4-33-1.3l-19.9,82.8c17.7,1.9,35.4,2.9,53.1,2.9,89.9,0,178.4-24.7,257-72.9,112.5-68.9,191.5-177.5,222.4-305.8,30.9-128.3,9.9-260.9-59-373.5-57.6-94.1-143-164.7-244.4-203.4M511.5,17.4c-89.9,0-178.4,24.7-257,72.9C141.9,159.1,62.9,267.7,32,396c-30.9,128.3-9.9,260.9,59,373.5,57.6,94.1,143,164.7,244.4,203.4l19.9-82.8c-79.6-32.8-146.6-89.8-192.4-164.6-57.2-93.3-74.5-203.4-48.9-309.8,25.6-106.4,91.1-196.5,184.4-253.7,65.2-39.9,138.6-60.5,213.2-60.5s22,.4,33,1.3l19.9-82.8c-17.7-1.9-35.4-2.9-53.1-2.9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 851.2,
    cy: 427.7,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 851.2,
    cy: 566.2,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 851.2,
    cy: 496.9,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 781.9,
    cy: 566.2,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 781.9,
    cy: 635.4,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 781.9,
    cy: 496.9,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 781.9,
    cy: 427.7,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 781.9,
    cy: 358.1,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 781.9,
    cy: 704.7,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 712.6,
    cy: 566.2,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 712.6,
    cy: 635.4,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 712.6,
    cy: 496.9,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 712.6,
    cy: 704.7,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 712.6,
    cy: 773.9,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 643.4,
    cy: 566.2,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 643.4,
    cy: 635.4,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 643.4,
    cy: 496.9,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 643.4,
    cy: 704.7,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 643.4,
    cy: 773.9,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 574.1,
    cy: 635.4,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 574.1,
    cy: 704.7,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 574.1,
    cy: 773.9,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 574.1,
    cy: 843.2,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 504.9,
    cy: 635.4,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 504.9,
    cy: 704.7,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 504.9,
    cy: 773.9,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 504.9,
    cy: 843.2,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 435.6,
    cy: 773.9,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 366.4,
    cy: 773.9,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 435.6,
    cy: 843.2,
    r: 26
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopWhiteTransparent);
export default __webpack_public_path__ + "static/media/desktop-white-transparent.ba221291dd8963740d23a20ec16cddc3.svg";
export { ForwardRef as ReactComponent };